<app-navbar />
<div class="suporte-container">
  <div class="suporte-header hero">
    <div class="hero-left">
      <div class="company">{{ companyName || 'VibeTex' }}</div>
      <h1>Central de Suporte</h1>
      <p class="hero-sub">Olá, <strong>{{ displayName || 'Usuário' }}</strong> — estamos aqui para ajudar.</p>
    </div>
    <div class="hero-right">
      <div class="header-actions">
        <button class="btn-ghost" (click)="showSolicitar()" [class.active]="!showList">Nova Solicitação</button>
        <button class="btn-ghost" (click)="showMinhasSolicitacoes()" [class.active]="showList">Minhas Solicitações</button>
      </div>
    </div>
  </div>

  <div class="suporte-content">
    <div class="form-card" *ngIf="!showList">
      <h2 *ngIf="!editMode">Nova Solicitação de Suporte</h2>
      <h2 *ngIf="editMode">Editar Solicitação</h2>
      
      <form [formGroup]="suporteForm" (ngSubmit)="onSubmit()">
        <!-- Campo Título -->
        <div class="form-group">
          <label for="titulo">Título <span class="required">*</span></label>
          <input 
            type="text" 
            id="titulo" 
            formControlName="titulo"
            placeholder="Digite o título da solicitação"
            class="form-control"
            [class.error]="titulo?.invalid && titulo?.touched"
          />
          <div class="error-message" *ngIf="titulo?.invalid && titulo?.touched">
            <span *ngIf="titulo?.errors?.['required']">O título é obrigatório</span>
            <span *ngIf="titulo?.errors?.['minlength']">O título deve ter no mínimo 5 caracteres</span>
          </div>
        </div>

        <!-- Campo Número da Vistoria -->
        <div class="form-group">
          <label for="numeroVistoria">Número da Vistoria</label>
          <input
            type="text"
            id="numeroVistoria"
            formControlName="numeroVistoria"
            placeholder="Informe o número da vistoria (se aplicável)"
            class="form-control"
            [class.error]="numeroVistoria?.invalid && numeroVistoria?.touched"
          />
          <div class="error-message" *ngIf="numeroVistoria?.invalid && numeroVistoria?.touched">
            <span *ngIf="numeroVistoria?.errors?.['pattern']">Digite apenas números</span>
          </div>
        </div>

        <!-- Campo Descrição -->
        <div class="form-group">
          <label for="descricao">Descrição do Problema <span class="required">*</span></label>
          <textarea 
            id="descricao" 
            formControlName="descricao"
            placeholder="Descreva detalhadamente o motivo do suporte..."
            rows="6"
            class="form-control"
            [class.error]="descricao?.invalid && descricao?.touched"
          ></textarea>
          <div class="error-message" *ngIf="descricao?.invalid && descricao?.touched">
            <span *ngIf="descricao?.errors?.['required']">A descrição é obrigatória</span>
            <span *ngIf="descricao?.errors?.['minlength']">A descrição deve ter no mínimo 10 caracteres</span>
          </div>
        </div>

        <!-- Campo Anexar Foto -->
        <div class="form-group">
          <label for="foto">Anexar Foto (Opcional)</label>
          <div class="file-input-wrapper">
            <input 
              type="file" 
              id="foto" 
              accept="image/*"
              (change)="onFileSelected($event)"
              class="file-input"
              #fileInput
            />
            <button 
              type="button" 
              class="btn-file-select"
              (click)="fileInput.click()"
            >
              Selecionar Arquivo
            </button>
            <span class="file-name" *ngIf="selectedFileName">{{ selectedFileName }}</span>
          </div>

          <!-- Preview da Imagem -->
          <div class="image-preview" *ngIf="previewUrl">
            <img [src]="previewUrl" alt="Preview" />
            <button type="button" class="btn-remove-file" (click)="removeFile()">
              <i class="icon-close"></i> Remover
            </button>
          </div>
        </div>

        <!-- Botões de Ação -->
        <div class="form-actions">
          <button 
            type="button" 
            class="btn btn-danger"
            (click)="showMinhasSolicitacoes()"
          >
            Cancelar
          </button>
          <button 
            type="submit" 
            class="btn btn-primary"
            [disabled]="suporteForm.invalid"
          >
            {{ editMode ? 'Atualizar Solicitação' : 'Enviar Solicitação' }}
          </button>
        </div>
      </form>
    </div>
    
    <div class="form-card list-card" *ngIf="showList">
      <h2>Minhas Solicitações</h2>
      <div *ngIf="!minhasSolicitacoes || minhasSolicitacoes.totalElements === 0" class="empty-list">
        <p>Você ainda não possui solicitações. Clique em "Nova Solicitação" para abrir uma.</p>
      </div>
      <div *ngIf="minhasSolicitacoes && minhasSolicitacoes.content.length">
        <div class="requests-grid">
          <div class="request-card" *ngFor="let s of minhasSolicitacoes.content">
            <div class="request-card-header">
              <div class="header-left">
                <div class="request-id">#{{ s.numeroExibicao || s.id }}</div>
                <h3 class="request-title">{{ s.titulo }}</h3>
              </div>
              <div class="header-right">
                <div class="request-status {{ s.status }}">{{ s.status | titlecase }}</div>
              </div>
            </div>

            <div class="request-card-body">
              <div class="body-left">
                <p class="request-desc">{{ s.descricao }}</p>
                <div class="request-details">
                  <span *ngIf="s.numeroVistoria" class="detail">Nº Vistoria: <strong>{{ s.numeroVistoria }}</strong></span>
                  <span class="detail">Criado: {{ s.criadoEm | date:'short' }}</span>
                  <span *ngIf="s.atualizadoEm && s.atualizadoEm !== s.criadoEm" class="detail request-updated">Atualizado: {{ s.atualizadoEm | date:'short' }}</span>
                </div>
              </div>
              <div class="body-right" *ngIf="s.fotos?.length">
                <div class="request-thumb"><img [src]="s.fotos?.[0]?.url" alt="foto"/></div>
              </div>
            </div>

            <div class="request-card-footer">
              <div class="footer-left">
                <small class="who">{{ s.nomeUsuario || s.nomeEmpresa ? (s.nomeUsuario || '') + (s.nomeEmpresa ? ' • ' + s.nomeEmpresa : '') : '' }}</small>
              </div>
                <div class="footer-right">
                <button *ngIf="(s.status | lowercase) === 'aberto'" type="button" class="btn btn-secondary" (click)="editSolicitacao(s)">Editar</button>
                <button type="button" class="btn btn-danger" (click)="cancelarSolicitacao(s.id)">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
